import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

// Providers.
import { WABaseService } from './wa-base.service';
import { LoggerService } from '../logger/logger-service';
import { EnvironmentService } from './environment-service';


@Injectable(
  {
    providedIn: 'root'
  }
)
export class MemStorageService extends WABaseService {

  protected storage: { [index: string]: any } = {};

  constructor(
    protected logger: LoggerService,
    protected env: EnvironmentService) {
    super(logger, env);
  }

  public put(key: string, data: any) {
    this.storage[key] = data;
  }

  public get(key: string): any {
    return this.storage[key];
  }

  public keyExists(key: string): boolean {
    return typeof this.storage[key] !== 'undefined';
  }

  public remove(key: string) {
    delete this.storage[key];
  }
}
